import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import {
  BackButton,
  DesktopDatepicker,
  Error,
  Loading,
  LoadingDialog,
  SocketIOLoading,
  ViewTitle,
} from '@iarcpsu/emanufac-components/src/components';
import { MQ_TASK } from '@iarcpsu/emanufac-constant';
import {
  currencyFormatter,
  moCostCalculation,
} from '@iarcpsu/emanufac-utils/functions';
import {
  Button,
  Card,
  CardContent,
  FormControlLabel,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
} from '@mui/material';
import hash from 'object-hash';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';

import * as actions from '@/redux/actions';

export default function EditManufacturingOrderDeposit({ title, subtitle }) {
  const dispatch = useDispatch();
  const manufacturingOrder = useSelector((state) => state.manufacturingOrder);
  const me = useSelector((state) => state.me);
  const history = useHistory();
  const params = useParams();
  const { control, handleSubmit } = useForm();
  const [referenceNumber, setReferenceNumber] = useState('');
  const [isDialogLoadingOn, setIsDialogLoadingOn] = useState(false);

  useEffect(() => {
    const refNo = hash({
      date: new Date(),
      user: me?.userData?._id,
    });

    setReferenceNumber(refNo);

    return () => {};
  }, []);

  const totalPrice = moCostCalculation(manufacturingOrder);

  const queryDataFromServer = async () => {
    try {
      dispatch(actions.manufacturingOrderGet(params.id, {}));
    } catch (error) {
      dispatch(actions.manufacturingOrderError());
    }
  };

  const handleOnSubmit = async (data) => {
    const payload = {
      deposit: data?.deposit?.is_deposit
        ? data.deposit
        : {
            is_deposit: false,
            amount: 0,
            deposit_date: null,
          },
      isUpdateDeposit: true,
      employee: me?.userData?._id,
      referenceNumber,
    };
    console.log('Deposit Payload', payload);
    try {
      await dispatch(actions.manufacturingOrderPut(params.id, payload));
      setIsDialogLoadingOn(true);
    } catch (error) {
      Swal.fire({
        title: 'บันทึกมัดจำไม่สำเร็จ',
        icon: 'error',
        text: error.message,
      });
    }
  };

  useEffect(() => {
    queryDataFromServer();
    return () => {};
  }, [params]);

  const handleSocketIOFunction = {
    onFail: (args) => {
      setIsDialogLoadingOn(false);
      Swal.fire({
        title: 'บันทึกมัดจำไม่สำเร็จ',
        icon: 'error',
        text: args.message,
      });
    },
    onSuccess: (args) => {
      setIsDialogLoadingOn(false);
      Swal.fire({
        title: 'บันทึกมัดจำสำเร็จ',
        icon: 'success',
      }).then(() => {
        history.goBack();
      });
    },
  };

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  if (manufacturingOrder.isLoading) {
    return <Loading />;
  }

  if (!manufacturingOrder.isLoading && manufacturingOrder.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <BackButton />
        <SocketIOLoading
          referenceNumber={referenceNumber}
          taskCode={MQ_TASK.UPDATE_MANUFAC_ORDER.status_code}
          handleFail={handleSocketIOFunction.onFail}
          handleSuccess={handleSocketIOFunction.onSuccess}
        />
        <LoadingDialog
          isLoading={isDialogLoadingOn}
          label="กำลังอัพเดทข้อมูลมัดจำ"
        />
        <div className="my-2">
          <form onSubmit={handleSubmit(handleOnSubmit)}>
            <Card>
              <CardContent>
                <div className="my-1 font-semibold">
                  แก้ไขมัดจำของคำสั้งผลิต
                </div>
                <div className="my-2">
                  <div className="my-2">
                    <Controller
                      control={control}
                      name="deposit.is_deposit"
                      defaultValue={manufacturingOrder?.deposit?.is_deposit}
                      render={({ field }) => (
                        <FormControlLabel
                          control={
                            <Switch {...field} defaultChecked={field.value} />
                          }
                          label="มัดจำ"
                        />
                      )}
                    />
                  </div>
                  <div className="my-1">วันที่มัดจำ</div>
                  <div className="my-2">
                    <Controller
                      control={control}
                      name="deposit.deposit_date"
                      defaultValue={
                        manufacturingOrder?.deposit?.deposit_date || new Date()
                      }
                      render={({ field }) => (
                        <DesktopDatepicker
                          {...field}
                          value={field.value}
                          fullWidth
                          label="วันที่มัดจำ"
                          size="small"
                        />
                      )}
                    />
                  </div>
                  <div className="my-1 mt-2 font-semibold">
                    รายละเอียดการมัดจำ
                  </div>
                </div>
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell>ราคาทั้งหมด </TableCell>
                        <TableCell>
                          {currencyFormatter.format(totalPrice || 0)}
                        </TableCell>
                        <TableCell>บาท</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell> มัดจำที่จ่ายไปแล้ว </TableCell>
                        <TableCell>
                          <Controller
                            name="deposit.amount"
                            control={control}
                            defaultValue={manufacturingOrder?.deposit?.amount}
                            render={({ field }) => (
                              <TextField
                                label="จำนวนเงินมัดจำ"
                                size="small"
                                fullWidth
                                {...field}
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell>บาท</TableCell>
                      </TableRow>{' '}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>{' '}
            <div className="flex justify-end my-1">
              <Button type="submit" variant="contained">
                บันทึก
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
  return <Error />;
}

EditManufacturingOrderDeposit.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditManufacturingOrderDeposit.defaultProps = {
  title: '',
  subtitle: '',
};
